/* ---------- BS-001's mounting plate and door bonded to the earthing busbar (CP-002 review 8.2, #3525) ----------
 * The enclosure's earth studs, -XE1 on the plate and -XE2 on the door, each take a strap from the busbar -WE1 (wiring.ts). A save
 * made before holds a panel wired without them, which the wiring step would now call missing. How such a save is read: the save
 * migration in packages/progress uses this (format 31). Self-contained on purpose, as breakers.ts: the migration imports this file
 * alone, not BS-001's pack. */

/** The two straps, in the order the panel's wiring list has them. */
export const BS001_STRAPS = [{ from: "WE1:18", to: "XE1:PE" }, { from: "WE1:19", to: "XE2:PE" }] as const;

/** A build record ({ placements, wires }) with the straps where the busbar is placed and already wired: the enclosure changed under the
 *  learner's work, so its straps come with it, as CP-002's did (format 30). The wiring step gives each the list's size,
 *  colour and mark when it loads. Anything else (the busbar not placed or not wired yet, a strap already there) keeps its wires. */
function build(b: any): any {
  const wires: any[] = Array.isArray(b?.wires) ? b.wires : [], placed = (Array.isArray(b?.placements) ? b.placements : []).some((p: any) => p?.tag === "WE1");
  const onBar = wires.some(w => [w?.from, w?.to].some(e => typeof e === "string" && e.startsWith("WE1:")));
  const same = (a: any, c: { from: string; to: string }) => [a?.from, a?.to].sort().join("|") === [c.from, c.to].sort().join("|");
  const add = placed && onBar ? BS001_STRAPS.filter(c => !wires.some(w => same(w, c))) : [];
  return add.length ? { ...b, wires: [...wires, ...add.map(c => ({ from: c.from, to: c.to }))] } : b;
}

const one = <A extends { ui?: any }>(s: A): A => s?.ui?.build ? { ...s, ui: { ...s.ui, build: build(s.ui.build) } } : s;
/** A saved BS-001 project with the plate's and the door's straps: its own work and each earlier attempt it keeps ("Start again", #1220). */
export function strapsBs001Save<T extends { ui?: any; attempts?: any[] }>(s: T): T {
  const out = one(s);
  return Array.isArray(s?.attempts) ? { ...out, attempts: s.attempts.map(a => one(a)) } : out;
}
